import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toast";
//import * as auth from "../Auth";
import axios from "axios";
import ScaleLoader from "react-spinners/ScaleLoader";
import { withTranslation } from "react-i18next";
import styled from "styled-components";
import Uploady, { useItemProgressListener } from "@rpldy/uploady";
import { getMockSenderEnhancer } from "@rpldy/mock-sender";
import UploadButton from "@rpldy/upload-button";
import UploadPreview from "@rpldy/upload-preview";
import ImageUploader from "react-images-upload";
import Toggle from "./../../themeToggle";

import "./style.css";
import {
  CreditCardIcon,
  KeyIcon,
  UserCircleIcon,
  UserGroupIcon,
  ViewGridAddIcon,
} from "@heroicons/react/outline";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
const compte = localStorage.getItem("compte");
const poste = localStorage.getItem("poste");
const token = localStorage.getItem("AccessToken");
const BackendURL = window.BackendURLCmk;
function Security({ t }) {
  const [user, setUser] = useState([]);
  const [loading, setloading] = useState("false");
  const [isError, setisError] = useState(false);
  //const user = useSelector((state) => state.auth.user, shallowEqual);
  // useEffect(() => {}, [user]);
  // const user = JSON.parse(localStorage.getItem('user'));
  const showCustom = () =>
    toast(t("succes.toast"), {
      backgroundColor: "#27d0b2",
      color: "#ffffff",
    });
  const saveUser = (values, setStatus, setSubmitting) => {
    // setloading(true);

    setTimeout(() => {
      setloading(false);
      var config = {
        headers: {
          Authorization: token,
        },
      };
      var lien = window.location.href;
      // console.log(lien);
      const var2 = lien.split("/");
      //console.log("kien ici", var2[2]);
      var var4 = var2[2].split(":");
      // console.log("kien ici", var4[0]);
      const result = axios
        .get(
          `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/EditCoordonneesConnexionIPBXV3API?compte=${compte}&poste=${poste}&passwd=${values.currentPassword}&new_passwd=${values.password}`,
          config
        )
        .then((res) => {
          console.log(res);
          showCustom();

          //  const data = res.data.collegues;
          // localStorage.setItem("tabcollegue", JSON.stringify(data));
          // this.setState({ redirectToReferrer: true });
          //  this.setState({ redirectToReferrer: true });
          //  this.setState({ redirectToReferrer: true });
          // this.getallgrpcoleegue(compte, poste, token);
          // For displaying Data
        })
        .catch(function (error) {
          console.log("yopiiiiiiiiii", error);

          //   if (error == "Error: Request failed with status code 401") {
          //     localStorage.clear();
          //     var link = "/";

          //     window.location.replace(link);
          //   } else {
          setloading(false);
          setSubmitting(false);
          setStatus(error);
          toast.error("ancien mot de passe incorrect");
          // }
        });
    }, 1000);
  };
  // Methods

  // UI Helpers
  const initialValues = {
    currentPassword: "",
    password: "",
    cPassword: "",
  };
  const Schema = Yup.object().shape({
    // username: Yup.string()
    //   .required("Username est requis")
    //   .when("currentPassword", {
    //     is: (val) => (val && val.length > 0 ? true : false),
    //     then: Yup.string().oneOf(
    //       [user.identifiant_externe],
    //       "username incorrect"
    //     ),
    //   }),
    // currentPassword: Yup.string()
    //   .required("mot de passe actuel est requis")
    //   .when("password", {
    //     is: (val) => (val && val.length > 0 ? true : false),
    //     then: Yup.string().oneOf(
    //       [user.mdp_interface_agent],
    //       "Mot de passe actuel incorrect"
    //     ),
    //   }),
    password: Yup.string().required("New Password is required"),
    cPassword: Yup.string()
      .required("Password confirmation is required")
      .when("password", {
        is: (val) => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf(
          [Yup.ref("password")],
          "Password and Confirm Password didn't match"
        ),
      }),
  });
  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };
  const formik = useFormik({
    initialValues,
    validationSchema: Schema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      saveUser(values, setStatus, setSubmitting);
    },
    onReset: (values, { resetForm }) => {
      resetForm();
    },
  });
  return (
    <div className="min-h-screen w-full bg-white flex dark:bg-gray-700  bg-gray-200">
      <div className="flex-1 flex  justify-center dark:bg-gray-800 mt-4  bg-white shadow sm:rounded-md sm:overflow-hidden mr-8 ">
        <div className="space-y-8 divide-y divide-gray-200 sm:space-y-5 w-full pl-40">
          <ToastContainer delay={9000} position={"top-right"} />{" "}
          <form className="" onSubmit={formik.handleSubmit}>
            {/* begin::Header */}

            <div>
              <h2 className="dark:text-white pb-8 pt-4 text-lg leading-6 mt-2 my-2 mx-2 font-medium text-gray-900">
                {t("change.pass")}
              </h2>
            </div>

            {/* begin::Form */}
            <div className="form">
              <div className="card-body">
                {/* begin::Alert */}
                {isError && (
                  <div
                    className="alert alert-custom alert-light-danger fade show mb-10"
                    role="alert"
                  >
                    <div className="alert-icon">
                      <span className="svg-icon svg-icon-3x svg-icon-danger"></span>
                    </div>
                    <div className="alert-text font-weight-bold">
                      Configure user passwords to expire periodically. Users
                      will need warning that their passwords are going to
                      expire,
                      <br />
                      or they might inadvertently get locked out of the system!
                    </div>
                    <div
                      className="alert-close"
                      onClick={() => setisError(false)}
                    >
                      <button
                        type="button"
                        className="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">
                          <i className="ki ki-close"></i>
                        </span>
                      </button>
                    </div>
                  </div>
                )}
                {/* end::Alert */}

                <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 dark:border-gray-500 sm:pt-5 mb-4">
                  <label className="dark:text-white block ml-3 text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                    {t("Mot.passe.actuel")}
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <input
                      type="password"
                      placeholder={t("Mot.passe.actuel")}
                      className={`mt-1 px-2 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 border dark:border-gray-500 border-gray-300  focus:border-transparent w-4/4 h-10 focus:ring-green-300  block w-full shadow-sm sm:text-sm border-gray-300 rounded-md ${getInputClasses(
                        "currentPassword"
                      )}`}
                      name="currentPassword"
                      {...formik.getFieldProps("currentPassword")}
                    />
                    {formik.touched.currentPassword &&
                    formik.errors.currentPassword ? (
                      <div className="invalid-feedback">
                        {formik.errors.currentPassword}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 dark:border-gray-500 sm:pt-5 mb-4">
                  <label className="dark:text-white block ml-3 text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                    {t("nv.mot.passe")}
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <input
                      type="password"
                      placeholder={t("nv.mot.passe")}
                      className={`mt-1 px-2 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 border dark:border-gray-500 border-gray-300  focus:border-transparent w-4/4 h-10 focus:ring-green-300  block w-full shadow-sm sm:text-sm border-gray-300 rounded-md ${getInputClasses(
                        "password"
                      )}`}
                      name="password"
                      {...formik.getFieldProps("password")}
                    />
                    {formik.touched.password && formik.errors.password ? (
                      <div className="invalid-feedback">
                        {formik.errors.password}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 dark:border-gray-500 sm:pt-5 mb-4">
                  <label className="dark:text-white block ml-3 text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                    {t("verify.mdp")}
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <input
                      type="password"
                      placeholder={t("verify.mdp")}
                      className={`mt-1 px-2 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 border dark:border-gray-500 border-gray-300  focus:border-transparent w-4/4 h-10 focus:ring-green-300  block w-full shadow-sm sm:text-sm border-gray-300 rounded-md ${getInputClasses(
                        "cPassword"
                      )}`}
                      name="cPassword"
                      {...formik.getFieldProps("cPassword")}
                    />
                    {formik.touched.cPassword && formik.errors.cPassword ? (
                      <div className="invalid-feedback">
                        {formik.errors.cPassword}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            <div className="px-4 py-3  text-center sm:px-6">
              {" "}
              {!formik.dirty ? (
                <button
                  type="submit"
                  className="dark:bg-gray-700 dark:text-gray-500 inline-flex justify-center py-3 px-7 dark:border-gray-500  border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-gray-200"
                  // disabled={
                  //   formik.isSubmitting || (formik.touched && !formik.isValid)
                  // }
                  disabled={!formik.dirty}
                >
                  {t("save")}
                </button>
              ) : (
                <button
                  type="submit"
                  className="inline-flex justify-center py-3 px-7 dark:border-gray-500 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                  // disabled={
                  //   formik.isSubmitting || (formik.touched && !formik.isValid)
                  // }
                  disabled={!formik.dirty}
                >
                  {t("save")}
                  {formik.isSubmitting}
                </button>
              )}
            </div>
            {/* end::Form */}
          </form>
        </div>
      </div>
    </div>
  );
}
export default withTranslation("common")(Security);
